module.exports = {
      id: "90837619b52f87d184349eab0becf5ddequipment-built-in-closet.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#90837619b52f87d184349eab0becf5ddequipment-built-in-closet.svg",
      toString: function () {
        return this.url;
      }
    }